import { render, staticRenderFns } from "./by-code.vue?vue&type=template&id=462aa24a"
import script from "./by-code.vue?vue&type=script&lang=js"
export * from "./by-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports